import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CONSTANTS } from 'src/app/constants';
import { ApiService } from 'src/app/shared/service/api.service';

@Component({
  selector: 'app-finaly-order-class-day',
  templateUrl: './finaly-order-class-day.component.html',
  styleUrls: ['./finaly-order-class-day.component.css'],
})
export class FinalyOrderClassDayComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }
  message: string = '';
  @Output() errorEmitter = new EventEmitter();

  constructor(private api: ApiService) { }
  totalNormal: number = 0;

  dataSource: any = {
    chart: {
      theme: 'fusion',
      paletteColors: '#B22222',
      maxBarHeight: '14',
      showValues: '1',
      baseFontSize: '13',
    },
    data: [],
    subCaption: `Total: ${this.totalNormal}`,
  };

  loading: boolean = true;
  errorApi: boolean = false;
  typeClassificationDescription: string = '';
  dataLabel: string = '';

  ngOnInit(): void {
    this.typeClassificationDescription = '';
  }

  filterItem(item: any) {
    this.totalNormal = 0;
    this.errorApi = false;
    this.loading = true;
    this.getOrderClassInformation(item);
  }

  async getOrderClassInformation(item: any) {
    if (!this.validateFilter(item)) return;
    this.dataSource.data = [];

    this.typeClassificationDescription = '';
    this.dataLabel = '';
    const itemProductAux =
      item.typeProduct != '' ? item.typeProduct : [0, 1, 2, 3];

    this.typeClassificationDescription =
      '- ' + item.typeClassificationDescription;

    var dataMin = new Date(item.dataMin);
    dataMin.setDate(dataMin.getDate() + 1);
    var dataMax = new Date(item.dataMax);
    dataMax.setDate(dataMax.getDate() + 1);
    this.dataLabel =
      dataMin.toLocaleDateString() + ' a ' + dataMax.toLocaleDateString();
    try {
      const result = await this.api
        .getFinalyOrderClassDayNormal(
          item.dataMin,
          item.dataMax,
          Number(item.typeClassification),
          itemProductAux,
          item.branch
        )
        .toPromise();
      if (result.items.length != 0) {
        this.totalNormal = 0;
        this.dataSource.data = [];
        result.items.forEach(
          (a: any) => (this.totalNormal += Number(a.normalQuantity))
        );
        result.items.map((el: any) => {
          if (el.normalQuantity > 0)
            this.dataSource.data.push({
              label: el.classificationDescription,
              value: el.normalQuantity,
            });
        });
        this.errorApi = false;
      } else {
        this.message = CONSTANTS.MESSAGES.DATA_NULL_FINALY_ORDERCLAS;
        this.errorApi = true;
      }
    } catch (ex) {
      this.loading = false;
      this.errorApi = true;
      this.formatErrorMensagem(ex.error[0].message);
    } finally {
        if(this.dataSource.data.length == 0){
          this.message = CONSTANTS.MESSAGES.DATA_NULL_FINALY_ORDERCLAS;
          this.formatErrorMensagem(CONSTANTS.MESSAGES.DATA_NULL_FINALY_ORDERCLAS);
          this.errorApi = true;
        }
      this.loading = false;
    }
  }

  validateFilter(item: any): boolean {
    if (
      item.typeClassification.length === 0
    ) {
      this.message = CONSTANTS.MESSAGES.DATA_NULL_FINALY_NULLCLASS;
      this.loading = false;
      this.errorApi = true;
      return false;
    }

    if (item.branch == '') {
      this.message = CONSTANTS.MESSAGES.DATA_BRANCH_NULL;
      this.loading = false;
      this.errorApi = true;
      return false;
    }
    if (item.dateInvalid) {
      this.message = CONSTANTS.MESSAGES.DATA_MIN_INVALID;
      this.loading = false;
      this.errorApi = true;
      return false;
    }
    return true;
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: Finaly-Normal \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }
}
